<template>
    <div v-if="readonly" class="textarea readonly">
        <div class="readonly-text" :style="{height:options.height+'px'}">{{value}}</div>
    </div>
    <div v-else class="textarea" :class="{'validate-error':!validateResult}">
        <textarea
            :name="options.field"
            v-model.lazy="value"
            @focus="focusHandle"
            @blur="blurHandle"
            :style="{height:options.height+'px'}"
        ></textarea>
        <div class="validate-error-icon" v-if="validateResult===false" @click.stop>
            <info-image @mouseenter.stop="errorIconMouseenter" @mouseleave="errorIconMouseleave"></info-image>
        </div>
    </div>
</template>
<script>
import infoImage from "../img/info.vue";
import BaseField from "../baseField/baseField.vue";
import Gikam from "../../../core/gikam-core";

export default {
    extends: BaseField,
    components: { infoImage },

    props: {
        options: Object,
        propValue: [String, Number],
        rowIndex: Number,
        cellIndex: Number,
        propReadonly: {
            type: Boolean,
            default: void 0
        },
        //编辑器中的边框等样式是否显示出来
        propInvisible: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            validateResult: true,
            readonly: Gikam.isNotEmpty(this.propReadonly)
                ? this.propReadonly
                : this.options.readonly,
            field: this.options.field,
            valueIsChange: false,
            value: this.propValue,
            invisible: this.propInvisible
        };
    },

    watch: {
        value() {
            this.valueIsChange = true;
            if (this.validate()) {
                this.validateResult = true;
                this.$emit(
                    "change",
                    this.options.field,
                    this.value,
                    this.rowIndex
                );
            } else {
                this.validateResult = false;
            }
        },
        propValue(val) {
            this.value = val;
        }
    },

    methods: {
        focusHandle() {
            this.validateResult = true;
            this.$emit("focus", this.options.field, this.value, this.rowIndex);
        },

        blurHandle() {
            if (!this.valueIsChange && !this.validate()) {
                this.validateResult = false;
            }
            this.valueIsChange = false;
        },

        errorIconMouseenter(event) {
            this.showErrorPanel(event);
        },

        errorIconMouseleave(event) {
            this.removeErrorPanel(event);
        }
    }
};
</script>

<style>
.textarea {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: stretch;
    min-height: 60px;
}

.textarea.readonly {
    color: #666;
    font-family: "Microsoft YaHei", serif;
    font-size: 12px;
    align-items: center;
}

.textarea textarea,
.textarea .readonly-text {
    width: 100%;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    color: rgba(0, 0, 0, 0.65);
    font-family: "Microsoft YaHei", serif;
    font-size: 12px;
    resize: none;
    padding-left: 8px;
}

.textarea .readonly-text {
    height: 100%;
    background-color: #f4f4f4;
    display: flex;
    align-items: center;
}

.textarea textarea:focus {
    outline: none;
}

.textarea.validate-error textarea {
    border-color: #ff6e6e;
}

.textarea textarea:focus {
    border: 1px solid rgba(0, 122, 255, 0.5);
}

.validate-error-icon {
    margin-left: -25px;
    display: flex;
    align-items: center;
}

.validate-error-icon svg {
    height: 20px;
    cursor: pointer;
}
</style>

